import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import useData from './useData';
import { useNavigate } from "react-router-dom";
import { useHttpError } from '../context/HttpErrorContext'; // add this

const useAxiosPrivate = () => {
    const navigate = useNavigate();
    const { auth, logout } = useData();
    const { setHttpError } = useHttpError(); // add this

    useEffect(() => {
        const reqIntercept = axiosPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    const token = localStorage.getItem('token');
                    if (token) {
                        config.headers['Authorization'] = `Bearer ${token}`;
                    }
                }
                return config;
            }, error => Promise.reject(error)
        );

        const resIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async (error) => {
                const prevReq = error?.config;

                if (error?.response?.status === 401 && !prevReq?.sent) {
                    prevReq.sent = true;
                    logout();
                    navigate("/login", {replace: true});
                    // don't setHttpError here — logout handles it
                }

                if (error?.response?.status === 403) {
                    setHttpError(error); // now routes to NotAuthorized
                }

                if (error?.response?.status === 500) {
                    setHttpError(error); // routes to ServerError
                }

                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivate.interceptors.request.eject(reqIntercept);
            axiosPrivate.interceptors.response.eject(resIntercept);
        };
    }, [auth, logout]);

    return axiosPrivate;
};

export default useAxiosPrivate;